import { useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import { HistoryTimeline } from '@/components/history/HistoryTimeline';
import { useAuditLog } from '@/hooks/useAuditLog';
import { toHistoryEvent } from '@/lib/history';

interface ActivityTimelineProps {
  productId?: number;
  orderId?: number;
  customerId?: number;
}

const PAGE_SIZE = 50;

/**
 * Peasy-style object history shown at the bottom of each detail page. Product
 * history includes variants and availability; order history includes lines and
 * refunds; customer history also includes the customer's orders.
 */
export function ActivityTimeline({
  productId,
  orderId,
  customerId,
}: ActivityTimelineProps) {
  const [limit, setLimit] = useState(PAGE_SIZE);
  const { data: entries, isLoading } = useAuditLog({
    product_id: productId,
    order_id: orderId,
    customer_id: customerId,
    limit,
  });

  const events = useMemo(
    () => (entries ?? []).map((entry) => toHistoryEvent(entry)),
    [entries],
  );
  const canLoadMore = (entries?.length ?? 0) === limit;

  return (
    <section className="mx-auto w-full max-w-2xl pt-6">
      <h2 className="mb-5 text-sm font-semibold text-foreground">Activity</h2>
      <HistoryTimeline events={events} isLoading={isLoading} />
      {canLoadMore && (
        <div className="mt-2 flex justify-center">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => setLimit((current) => current + PAGE_SIZE)}
          >
            Show older
          </Button>
        </div>
      )}
    </section>
  );
}
